import * as React from "react";
import { Switch, Route } from "react-router-dom";
import MainLayout from "layout/main";
import { UserRole } from "user/constants";
import ProtectedRoute from "routes/protected";
import Admin from "page/admin";
import Calendar from "page/calendar/calendar";
import MyPages from "page/user/my-pages";
import UsersList from "page/user/list";
import EditUser from "page/user/edit";

export const routes = (
    <MainLayout>
        <Switch>
            <ProtectedRoute
                path={"/admin"}
                component={Admin}
                roles={[UserRole.Administrator]}
                redirectRoute={"/Account/Login?returnUrl=/admin"}
            />
            <ProtectedRoute
                path={"/user/list"}
                component={UsersList}
                roles={[UserRole.Administrator]}
            />
            <ProtectedRoute
                path={"/user/edit/:id?"}
                component={EditUser}
                roles={[UserRole.Administrator]}
            />

            <ProtectedRoute path={"/user/my-pages"} component={MyPages} />

            <Route
                path={"/calendar/:sizeName/:step"}
                render={(props: any) => (
                    <Calendar {...props} routeType="calendar" />
                )}
            />

            <Route
                path={"/notebook/:sizeName/:step"}
                render={(props: any) => (
                    <Calendar {...props} routeType={"notebook"} />
                )}
            />

            <Route path={"*"} component={Calendar} routeType="calendar" />
        </Switch>
    </MainLayout>
);
